import { selectAll } from 'd3';

export class LwGeneralGraph {
    element: any;
    constructor(element: any) {
        this.element = element;
    }

    remove() {
        selectAll("SD-graph").remove();
        selectAll('.y3.graph-container').remove();
    }
}
